import React from 'react';
import styles from './CardTitle.module.scss';

// eslint-disable-next-line max-lines-per-function

export const CardTitle: React.FC<{ text?: string | JSX.Element; style?: React.CSSProperties; type?: 'capital' | 'uppercase' }> = ({
  text,
  style,
  type,
  children,
}) => {
  return (
    <div className={type === 'capital' ? styles.cardTitleUpperCase : styles.cardTitle} style={style}>
      {text ?? children}
    </div>
  );
};

export default CardTitle;
